import { rem } from 'polished';
import styled, { css } from 'styled-components';

import { Header } from '@vimeo/iris/typography';
import { black, grayscale } from '@vimeo/iris/color';
export { MegaHeader, AlbumDescription } from '../AlbumHeader/CustomGridHeaderStyled';
import { Button } from '@vimeo/iris/components';
import { PaperPlane } from '@vimeo/iris/icons';

export const CustomLogoWrapper = styled.div`
  position: relative;
  width: 100px;
  overflow: hidden;
  max-height: 200px;
  img {
    width: 100%;
    height: auto;
  }
`;

export const SearchButton = styled(Button)`
  margin-right: ${rem(12)};
`;

export const StartWatchingButton = styled(Button)`
  margin: ${rem(10)} 0;
`;

interface SearchProps {
  isSearching: boolean;
}

function getSearchDisplay({ isSearching }: SearchProps) {
  return css`
    display: ${isSearching ? 'none' : 'inherit'};
  `;
}
export const AlbumInfo = styled.div`
  text-align: left;
`;

export const AlbumTitle = styled(Header).attrs({ size: '1' })`
  font-weight: 300;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const ShareIcon = styled(PaperPlane)`
  margin-left: ${rem(12)};
  path {
    fill: white;
  }
`;

export const CurrentVideoTitle = styled(Header).attrs({ size: '4' })`
  margin-top: ${rem(4)};
  margin-bottom: ${rem(20)};
`;

const emptyInfoBarStyles = css`
  height: 45vh;
  background: linear-gradient(
    rgba(${grayscale(800)}, 0.35) 0%,
    rgba(${grayscale(800)}, 0.2) 35%,
    rgba(${grayscale(800)}, 0.1) 70%,
    rgba(${grayscale(800)}, 0.015) 85%,
    rgba(${grayscale(800)}, 0) 100%
  );
`;

export const InfoBar = styled.div<{
  isEmpty: boolean;
  isSearching: boolean;
  thumbnail?: string;
}>`
  width: 100%;

  padding: 0 ${rem(60)} ${({ isSearching }: SearchProps) => !isSearching && rem(80)};

  ${({ isSearching, thumbnail }) =>
    (isSearching &&
      css`
        background: ${black};
      `) ||
    (thumbnail &&
      css`
        background-size: cover;
        background-image: linear-gradient(
            rgba(0, 0, 0, 0.25) 0%,
            rgba(0, 0, 0, 0.25) 50%,
            rgba(0, 0, 0, 0.25) 100%
          ),
          url(${thumbnail});
      `) ||
    css`
      background: linear-gradient(
        to right,
        ${black},
        rgba(0, 0, 0, 0.95) 10%,
        rgba(0, 0, 0, 0.65) 30%,
        rgba(0, 0, 0, 0.15) 50%,
        rgba(0, 0, 0, 0.05) 90%,
        transparent 100%
      );
    `};

  z-index: 101;

  @media screen and (max-width: 500px) {
    padding: 0
      ${({ isSearching }: SearchProps) => (isSearching ? `${rem(40)} ${rem(80)}` : `${rem(40)}`)};
  }

  ${({ isEmpty }) => isEmpty && emptyInfoBarStyles}
  ${AlbumInfo} {
    ${getSearchDisplay}
  }
`;

export const CountAndShareButton = styled.div<SearchProps>`
  height: ${rem(90)};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
  margin-bottom: ${({ isSearching }: SearchProps) => (isSearching ? '1rem' : '2rem')};
  padding-top: 1.5rem;
`;

export const VideoCount = styled.span`
  color: white;
`;
